const pageNameKey = "machinesListRow";

export const machinesListRowEn = {
  [pageNameKey]: {
    sourceIconAltText: "Source",
    incomingRequested: "Incoming Request",
    active: "Active",
    viewSourceInfo: "View Source Info",
    noIpAddress: "No IP Address available",
    noSourceType: "N/A",
    goToDashboard: "Go to Dashboard",
    goToConditionMonitoring: "Go to Condition Monitoring",
    noGateway: "N/A Gateway",
    moreOptions: "More Options",
    noSource: "N/A",
    request: "Request",
    requested: "Requested",
    goToTreeStructure: "Go to Tree Structure",
    noVendorId: "No vendor ID available",
    noMachineId: "No Machine ID available",
    copyTooltip: "Copy Machine ID",
    successMessage: "copied to clipboard",
    errorMessage: "Error copying to clipboard",
    machineId: "Machine ID",
    goToMachineSettings: "Go to Machine Settings",
    goToShotDataTable: "Go to Shot data table",
    ticketStatusUnstableConnectionWarning:
      "The connection to the server is currently unstable, we might not be able to update the status of your tickets",
    closing: "Closing",
    inProgressPrivate: "Private Ongoing",
    inProgressSession: "In Progress",
    joinSession: "Join Session",
    inProgressPrivateTooltip:
      "This session is private and can't be joined. Contact the technician if you need access.",
    joinSessionTooltip: "Join active screen sharing session as viewer.",
    viewing: "Viewing",
    viewingTooltip:
      "You've joined as a viewer.\nYou can see the screen but cannot interact with the machine.",
    sessionEndedByTechnician:
      "The session has ended. The technician closed the remote connection.",
  },
};

export const machinesListRowPtBr = {
  [pageNameKey]: {
    sourceIconAltText: "Fonte",
    incomingRequested: "Solicitação recebida",
    active: "Ativo",
    viewSourceInfo: "Ver informações da fonte",
    noIpAddress: "Nenhum endereço IP disponível",
    noSourceType: "N/D",
    goToDashboard: "Ir para o painel",
    goToConditionMonitoring: "Acesse o Monitoramento de condição",
    noGateway: "Gateway N/A",
    moreOptions: "Mais opções",
    noSource: "N/D",
    request: "Solicitação",
    requested: "Solicitado",
    goToTreeStructure: "Ir para Estrutura de Árvore",
    noVendorId: "Nenhum ID do fornecedor disponível",
    noMachineId: "Nenhum ID de máquina disponível",
    copyTooltip: "Copiar ID de máquina",
    successMessage: "Copiado para a área de transferência",
    errorMessage: "Erro ao copiar para a área de transferência",
    machineId: "ID de máquina",
    goToMachineSettings: "Vá para as Configurações da máquina",
    goToShotDataTable: "Ir para tabela de dados de shot",
    ticketStatusUnstableConnectionWarning:
      "A conexão com o servidor está instável no momento e talvez não consigamos atualizar o status dos seus tickets",
    closing: "Fechando",
    inProgressPrivate: "Privada em andamento",
    inProgressSession: "Em andamento",
    joinSession: "Entrar na sessão",
    inProgressPrivateTooltip:
      "Esta sessão é privada e não pode ser acessada. Entre em contato com o técnico se precisar de acesso.",
    joinSessionTooltip:
      "Entrar na sessão ativa de compartilhamento de tela como visualizador.",
    viewing: "Visualizando",
    viewingTooltip:
      "Você entrou como visualizador.\nVocê pode ver a tela, mas não pode interagir com a máquina.",
    sessionEndedByTechnician:
      "A sessão foi encerrada. O técnico fechou a conexão remota.",
  },
};

export const machinesListRowDe = {
  [pageNameKey]: {
    sourceIconAltText: "Quelle",
    incomingRequested: "Eingehende Anfrage",
    active: "Aktiv",
    viewSourceInfo: "Quelleninfo anzeigen",
    noIpAddress: "Keine IP-Adresse verfügbar",
    noSourceType: "N/A",
    goToDashboard: "Zum Dashboard gehen",
    goToConditionMonitoring: "Zur Zustandsüberwachung gehen",
    noGateway: "N/A Gateway",
    moreOptions: "Weitere Optionen",
    noSource: "N/A",
    request: "Anfragen",
    requested: "Angefordert",
    goToTreeStructure: "Zur Baumstruktur gehen",
    noVendorId: "Keine Hersteller-ID verfügbar",
    noMachineId: "Keine Maschinen-ID verfügbar",
    copyTooltip: "Maschinen-ID kopieren",
    successMessage: "in die Zwischenablage kopiert",
    errorMessage: "Fehler beim Kopieren in die Zwischenablage",
    machineId: "Maschinen-ID",
    goToMachineSettings: "Gehen Sie zu Maschineneinstellungen",
    goToShotDataTable: "Zur Shot-Datentabelle gehen",
    ticketStatusUnstableConnectionWarning:
      "Die Verbindung zum Server ist derzeit instabil, wir können den Status Ihrer Tickets möglicherweise nicht aktualisieren.",
    closing: "Schließen",
    inProgressPrivate: "Privat laufend",
    inProgressSession: "In Bearbeitung",
    joinSession: "Sitzung beitreten",
    inProgressPrivateTooltip:
      "Diese Sitzung ist privat und kann nicht beigetreten werden. Kontaktieren Sie den Techniker, wenn Sie Zugriff benötigen.",
    joinSessionTooltip:
      "Aktiver Bildschirmfreigabe-Sitzung als Zuschauer beitreten.",
    viewing: "Zuschauer",
    viewingTooltip:
      "Sie sind als Zuschauer beigetreten.\nSie können den Bildschirm sehen, aber nicht mit der Maschine interagieren.",
    sessionEndedByTechnician:
      "Die Sitzung wurde beendet. Der Techniker hat die Remote-Verbindung geschlossen.",
  },
};

export const machinesListRowZhHans = {
  [pageNameKey]: {
    sourceIconAltText: "来源",
    incomingRequested: "传入请求",
    active: "活动",
    viewSourceInfo: "查看源信息",
    noIpAddress: "无可用的IP地址",
    noSourceType: "N/A",
    goToDashboard: "转到仪表板",
    goToConditionMonitoring: "转到状态监控",
    noGateway: "N/A 网关",
    moreOptions: "更多选项",
    noSource: "N/A",
    request: "请求",
    requested: "已请求",
    goToTreeStructure: "转到树结构",
    noVendorId: "无可用的制造商ID",
    noMachineId: "无可用的机器ID",
    copyTooltip: "复制机器ID",
    successMessage: "已复制到剪贴板",
    errorMessage: "复制到剪贴板时出错",
    machineId: "机器ID",
    goToMachineSettings: "转到机器设置",
    goToShotDataTable: "转到注射数据表",
    ticketStatusUnstableConnectionWarning:
      "当前与服务器的连接不稳定，我们可能无法更新您的工单状态。",
    closing: "关闭",
    inProgressPrivate: "私有进行中",
    inProgressSession: "进行中",
    joinSession: "加入会话",
    inProgressPrivateTooltip:
      "此会话为私有，无法加入。如需访问，请联系技术人员。",
    joinSessionTooltip: "以查看者身份加入正在进行的屏幕共享会话。",
    viewing: "观看中",
    viewingTooltip:
      "您已以观看者身份加入。\n您可以看到屏幕，但无法与机器交互。",
    sessionEndedByTechnician: "会话已结束。技术人员已关闭远程连接。",
  },
};

export const machinesListRowIt = {
  [pageNameKey]: {
    sourceIconAltText: "Macchina",
    incomingRequested: "Richiesta in arrivo",
    active: "Attivo",
    viewSourceInfo: "Visualizza info macchina",
    noIpAddress: "Nessun indirizzo IP disponibile",
    noSourceType: "N/A",
    goToDashboard: "Vai alla dashboard",
    goToConditionMonitoring: "Vai al monitoraggio parametri e allarmi",
    noGateway: "N/A Gateway",
    moreOptions: "Altre opzioni",
    noSource: "N/A",
    request: "Richiedi",
    requested: "Richiesto",
    goToTreeStructure: "Vai alla visualizzazione struttura nodi",
    noVendorId: "Nessun ID fornitore disponibile",
    noMachineId: "Nessun ID macchina disponibile",
    copyTooltip: "Copia ID macchina",
    successMessage: "Copiato negli appunti",
    errorMessage: "Errore durante la copia negli appunti",
    machineId: "ID macchina",
    goToMachineSettings: "Vai alle impostazioni macchina",
    goToShotDataTable: "Vai alla tabella dati shot",
    ticketStatusUnstableConnectionWarning:
      "La connessione al server al momento è instabile, potremmo non essere in grado di aggiornare lo stato dei tuoi ticket",
    closing: "In chiusura",
    inProgressPrivate: "Privata in corso",
    inProgressSession: "In corso",
    joinSession: "Partecipa alla sessione",
    inProgressPrivateTooltip:
      "Questa sessione è privata e non può essere raggiunta. Contatta il tecnico se hai bisogno di accesso.",
    joinSessionTooltip:
      "Partecipa alla sessione attiva di condivisione schermo come osservatore.",
    viewing: "Visualizzando",
    viewingTooltip:
      "Hai partecipato come osservatore.\nPuoi vedere lo schermo ma non puoi interagire con la macchina.",
    sessionEndedByTechnician:
      "La sessione è terminata. Il tecnico ha chiuso la connessione remota.",
  },
};

export const machinesListRowEs = {
  [pageNameKey]: {
    sourceIconAltText: "Fuente",
    incomingRequested: "Solicitud entrante",
    active: "Activo",
    viewSourceInfo: "Ver información de la fuente",
    noIpAddress: "No hay dirección IP disponible",
    noSourceType: "N/A",
    goToDashboard: "Ir al panel",
    goToConditionMonitoring: "Ir a monitorización de condición",
    noGateway: "N/A Gateway",
    moreOptions: "Más opciones",
    noSource: "N/A",
    request: "Solicitud",
    requested: "Solicitado",
    goToTreeStructure: "Ir a estructura en árbol",
    noVendorId: "No hay ningún ID de proveedor disponible",
    noMachineId: "No hay ningún ID de máquina disponible",
    copyTooltip: "Copiar ID de máquina",
    successMessage: "copiado al portapapeles",
    errorMessage: "Error al copiar al portapapeles",
    machineId: "ID de máquina",
    goToMachineSettings: "Ir a la configuración de la máquina",
    goToShotDataTable: "Ir a la tabla de datos de shot",
    ticketStatusUnstableConnectionWarning:
      "La conexión con el servidor es inestable en este momento; es posible que no podamos actualizar el estado de tus tickets.",
    closing: "Cerrando",
    inProgressPrivate: "Privada en curso",
    inProgressSession: "En curso",
    joinSession: "Unirse a la sesión",
    inProgressPrivateTooltip:
      "Esta sesión es privada y no se puede unir. Contacte al técnico si necesita acceso.",
    joinSessionTooltip:
      "Unirse a la sesión activa de pantalla compartida como observador.",
    viewing: "Visualizando",
    viewingTooltip:
      "Te has unido como observador.\nPuedes ver la pantalla pero no puedes interactuar con la máquina.",
    sessionEndedByTechnician:
      "La sesión ha finalizado. El técnico cerró la conexión remota.",
  },
};

export const machinesListRowNl = {
  [pageNameKey]: {
    active: "Actief",
    closing: "Sluiten",
    copyTooltip: "Machine-ID kopiëren",
    errorMessage: "Fout bij kopiëren naar klembord",
    goToConditionMonitoring: "Ga naar conditiebewaking",
    goToDashboard: "Ga naar dashboard",
    goToMachineSettings: "Ga naar machine-instellingen",
    goToShotDataTable: "Ga naar shot-gegevens tabel",
    goToTreeStructure: "Ga naar boomstructuur",
    incomingRequested: "Binnenkomend verzoek",
    inProgressPrivate: "Privé actief",
    inProgressSession: "Bezig",
    inProgressPrivateTooltip:
      "Deze sessie is privé en kan niet worden bijgewoond. Neem contact op met de technicus als u toegang nodig heeft.",
    joinSession: "Deelnemen aan sessie",
    joinSessionTooltip:
      "Neem deel aan de actieve schermdelingssessie als kijker.",
    machineId: "Machine-ID",
    moreOptions: "Meer opties",
    noGateway: "N.v.t. gateway",
    noIpAddress: "Geen IP-adres beschikbaar",
    noMachineId: "Geen machine-ID beschikbaar",
    noSource: "N.v.t.",
    noSourceType: "N.v.t.",
    noVendorId: "Geen leverancier-ID beschikbaar",
    request: "Verzoek",
    requested: "Aangevraagd",
    sessionEndedByTechnician:
      "De sessie is beëindigd. De technicus heeft de externe verbinding gesloten.",
    sourceIconAltText: "Bron",
    successMessage: "gekopieerd naar klembord",
    ticketStatusUnstableConnectionWarning:
      "De verbinding met de server is momenteel instabiel. Mogelijk kunnen wij de status van uw tickets niet bewerken.",
    viewing: "Kijken",
    viewingTooltip:
      "U bent toegetreden als kijker.\nU kunt het scherm zien, maar niet met de machine communiceren.",
    viewSourceInfo: "Broninformatie weergeven",
  },
};

export const machinesListRowTr = {
  [pageNameKey]: {
    active: "Aktif",
    closing: "Kapanış",
    copyTooltip: "Makine Kimliğini Kopyala",
    errorMessage: "Panoya kopyalanırken hata oluştu",
    goToConditionMonitoring: "Durum İzlemeye Git",
    goToDashboard: "Kontrol Paneline Git",
    goToMachineSettings: "Makine Ayarlarına Git",
    goToTreeStructure: "Ağaç Yapısına Git",
    incomingRequested: "Gelen Talep",
    inProgressPrivate: "Özel Devam Ediyor",
    inProgressPrivateTooltip:
      "Bu oturum özeldir ve katılamazsınız. Erişime ihtiyacınız varsa teknisyenle iletişime geçin.",
    inProgressSession: "Devam etmekte",
    joinSession: "Oturuma Katılın",
    joinSessionTooltip:
      "Etkin ekran paylaşımı oturumuna izleyici olarak katılın.",
    machineId: "Makine Kimliği",
    moreOptions: "Daha Fazla Seçenek",
    noGateway: "Yok Ağ Geçidi",
    noIpAddress: "IP Adresi mevcut değil",
    noMachineId: "Makine Kimliği mevcut değil",
    noSource: "Yok",
    noSourceType: "Yok",
    noVendorId: "Satıcı kimliği mevcut değil",
    request: "Rica etmek",
    requested: "İstendi",
    sessionEndedByTechnician:
      "Oturum sona erdi. Teknisyen uzak bağlantıyı kapattı.",
    sourceIconAltText: "Kaynak",
    successMessage: "panoya kopyalandı",
    ticketStatusUnstableConnectionWarning:
      "Sunucuyla bağlantı şu anda kararsız, biletlerinizin durumunu güncelleyemeyebiliriz",
    viewing: "Görüntüleniyor",
    viewingTooltip:
      "İzleyici olarak katıldınız.\\nEkranı görebilirsiniz ancak makineyle etkileşimde bulunamazsınız.",
    viewSourceInfo: "Kaynak Bilgilerini Görüntüle",
    goToShotDataTable: "Atış veri tablosuna git",
  },
};
